import Vue from 'vue'
import VueRouter from 'vue-router'
import Footer from '../layout/Footer.vue'
import Header from '../layout/Header.vue'
import Home from '../views/Home.vue'
import Cafe from '../views/Cafe.vue'
import Blog from '../views/Blog.vue'
import Bar from '../views/Bar.vue'
import Contact from '../views/Contact.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    components: { default: Home, header: Header, footer: Footer }
  },
  {
    path: '/cafe',
    name: 'Cafe',
    components: { default: Cafe, header: Header, footer: Footer }
  },
  {
    path: '/bar',
    name: 'Bar',
    components: { default: Bar, header: Header, footer: Footer }
  },
  {
    path: '/blog',
    name: 'Blog',
    components: { default: Blog, header: Header, footer: Footer }
  },
  {
    path: '/contact',
    name: 'Contact',
    components: { default: Contact, header: Header, footer: Footer }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
